// extracted by mini-css-extract-plugin
module.exports = {"productInfo":"ProductInformation_productInfo__3bfc3","variantInfo":"ProductInformation_variantInfo__bd92b"};